<h1 class="text-sm mb-5 text-color-secondary">
  {{ 'shared.modal.component.add_vehicle.choose_vehicle'|translate|uppercase }}
</h1>
<p-tabView (activeIndexChange)="selectVehicleType($event)">
  <p-tabPanel *ngFor="let vehicleType of vehicleTypes" [header]="vehicleType.name">
    <ng-container *ngIf="isCarVehicleType(vehicleType.code)">
      <form [formGroup]="vehicleForm" novalidate>
        <div class="grid mt-2">
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="make"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.make' | translate"
                [options]="makes"
                [showClear]="true"
                (onChange)="seekModels([[selectedVehicleTypeVM], [make.value]], ['model', 'bodyType', 'bodyGen', 'edition', 'transmission'])"
                (onClear)="clearAfterMakeSelection()"
                #make
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="model"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.model' | translate"
                [options]="models"
                [showClear]="true"
                (onChange)="seekBodyTypes([[selectedVehicleTypeVM], [make.value], [model.value]], ['bodyType', 'bodyGen', 'edition', 'transmission'])"
                (onClear)="clearAfterModelSelection()"
                #model
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="bodyType"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.body_type' | translate"
                [options]="bodyTypes"
                [showClear]="true"
                (onChange)="seekBodyGens([[selectedVehicleTypeVM], [make.value], [model.value], [bType.value]], ['bodyGen', 'edition', 'transmission'])"
                (onClear)="clearAfterBodyTypeSelection()"
                #bType
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="bodyGen"
                filter="true"
                dataKey="@id"
                optionLabel="displayName"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.body_gen' | translate"
                [options]="bodyGens"
                [showClear]="true"
                (onChange)="seekEditions([[selectedVehicleTypeVM], [make.value], [model.value], [bType.value], [bGen.value]], ['edition', 'transmission'])"
                (onClear)="clearAfterBodyGenSelection()"
                #bGen
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="edition"
                filter="true"
                dataKey="@id"
                optionLabel="displayName"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.edition' | translate"
                [options]="editions"
                [showClear]="true"
                (onChange)="seekTransmissions(['transmission'])"
                (onClear)="clearAfterEditionSelection()"
                #edition
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="transmission"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.transmission' | translate"
                [options]="transmissions"
                [showClear]="true"
                (onChange)="seekVehicle()"
                (onClear)="clearAfterTransmissionSelection()"
                #transmission
              >
              </p-dropdown>
            </div>
          </div>
        </div>
        <!--  <div class="grid">-->
        <!--    <div class="col-12 p-fluid">-->
        <!--      <p *ngIf="vType.selectedOption">{{'shared.modal.component.add_vehicle.choice' | translate}}</p>-->
        <!--      <p class="font-weight-bold">-->
        <!--        {{vType?.label}} {{make?.label}}-->
        <!--        {{bType?.label}} {{model?.label}}-->
        <!--        {{bGen?.label}} {{edition?.label}}-->
        <!--      </p>-->
        <!--    </div>-->
        <!--  </div>-->
      </form>
    </ng-container>
    <ng-container *ngIf="isMotorcycleLikeVehicleType(vehicleType.code)">
      <form [formGroup]="vehicleForm" novalidate>
        <div class="grid mt-2">
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="make"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.make' | translate"
                [options]="makes"
                [showClear]="true"
                (onChange)="seekModels([[selectedVehicleTypeVM], [make.value]], ['model', 'bodyType', 'edition', 'transmission'])"
                (onClear)="clearAfterMakeSelection()"
                #make
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="model"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.model' | translate"
                [options]="models"
                [showClear]="true"
                (onChange)="seekBodyTypes([[selectedVehicleTypeVM], [make.value], [model.value], ['bodyType', 'edition']])"
                (onClear)="clearAfterModelSelection()"
                #model
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="bodyType"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.body_type' | translate"
                [options]="bodyTypes"
                [showClear]="true"
                (onChange)="seekEditions([[selectedVehicleTypeVM], [make.value], [model.value], [bType.value]], ['edition', 'transmission'])"
                (onClear)="clearAfterBodyTypeSelection()"
                #bType
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                *ngIf="editions.length"
                formControlName="edition"
                filter="true"
                dataKey="@id"
                optionLabel="displayName"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.edition' | translate"
                [options]="editions"
                [showClear]="true"
                (onChange)="seekTransmissions(['transmission'])"
                (onClear)="clearAfterEditionSelection()"
                #edition
              >
              </p-dropdown>
            </div>
          </div>
          <div class="col-12 lg:col-6 p-fluid">
            <div class="p-field">
              <p-dropdown
                formControlName="transmission"
                filter="true"
                dataKey="@id"
                optionLabel="name"
                appendTo="body"
                [autofocus]="false"
                [autofocusFilter]="false"
                [placeholder]="'shared.modal.component.add_vehicle.form.placeholder.transmission' | translate"
                [options]="transmissions"
                [showClear]="true"
                (onChange)="seekVehicle()"
                (onClear)="clearAfterTransmissionSelection()"
                #transmission
              >
              </p-dropdown>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </p-tabPanel>
</p-tabView>
